import { render, staticRenderFns } from "./ShopHeaderPreview.vue?vue&type=template&id=679fcd80&scoped=true"
import script from "./ShopHeaderPreview.vue?vue&type=script&lang=js"
export * from "./ShopHeaderPreview.vue?vue&type=script&lang=js"
import style0 from "./ShopHeaderPreview.vue?vue&type=style&index=0&id=679fcd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679fcd80",
  null
  
)

export default component.exports